module.exports = __webpack_public_path__ + "media/images/landkit/portfolio/portfolio-14-57cf1bb8c2d52b8d8e85b643b915eeef.jpg";